import { LoginError } from "../thunks/login";
import { RootState } from "../../reducers";

export const signUpErrorSelector = (rootState: RootState): LoginError =>
  rootState.login.signUpError;
